jQuery(document).ready(function($) {
  /*----- utils -----*/
  const isMobile = () => {
    return $(window).width() <= 800;
  };


  /*----- sticky banner -----*/
  const comparisonPage = document.querySelector('.comparison-page');

  function addClassFixed (elem) {
    if ($(elem).hasClass('sticky')) {
      return;
    }
    $(elem).addClass('sticky');
  }

  function removeClassFixed (elem) {
    if ($(elem).hasClass('sticky')) {
    $(elem).removeClass('sticky');
    }
  }

  function stickyHandler(stickyBlock,tableBlock) {

    if (($(this).scrollTop()+stickyBlock.outerHeight()) > tableBlock.offset().top) {
      addClassFixed(stickyBlock);
    } else{
      removeClassFixed(stickyBlock)
    }

  };

  if (comparisonPage) {
    const $tableBlockMobile = $('.mobile-only .comparison-table__body');
    const $tableBlockDesktop = $('.desktop-only .comparison-table__body');
    $(window).scroll(function() {
      const $stickyMobile = $('.mobile-only .comparison-table__head');
      const $stickyDesktop = $('.desktop-only .comparison-table__head');
      if (isMobile()) {
         stickyHandler($stickyMobile,$tableBlockMobile);
      } else {
         stickyHandler( $stickyDesktop,$tableBlockDesktop);
      }
    });
  }
});





